/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-constant-condition */
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { RootState } from '&store/store';

import { AboutUsWrapper } from './aboutUs.styled';
import BackgroundImg from '&assets/images/AWS-Empty-8.jpg';
import AboutUsImg from '&assets/images/AWS-House-8.jpg';
import Container from '../../components/container/container.component';

type ReduxProps = ConnectedProps<typeof connector>;

const AboutUsComponent = (props: ReduxProps) => {
	const { t } = useTranslation(['home']);

	return (
		<AboutUsWrapper backgroundImage={BackgroundImg}>
			<div className="challenge-header">
				<p className="challenge-name">About Us</p>
			</div>
			<Container className="flex-between">
				<div className="content">
					<h2 className="title">About GUST Innovation Hub</h2>
					<p className="description">
						Welcome to the GUST Innovation Hub, a first of its kind
						collaboration with Amazon Web Services (AWS). GUST takes pride in
						being the sole university in Kuwait to offer AWS Academy services.
						<br />
						<br />
						GUST's Innovation Hub offers a variety of products powered by AWS;
						including technical workshops, educational programs, executive
						education programs, innovation/startup challenges, and employment
						activation initiatives. Through these offerings we aim to foster an
						atmosphere that encourages unconventional thinking, groundbreaking
						innovations, ongoing learning, creativity, and professional
						development.
						<br />
						<br /> This collaboration marks a significant leap forward in our
						mission to accelerate progress and reshape the business landscape
						through the power of technology.
						<br />
						<br />
						Our focus extends beyond borders, actively contributing to the
						development of regional talent and fostering collaboration on a
						broader scale.
					</p>
				</div>
				<img src={AboutUsImg} alt="" className="main-image" />
			</Container>
		</AboutUsWrapper>
	);
};

const mapStateToProps = (state: RootState) => ({
	challenge: state.challengeDetails.challenge,
	loading: state.challengeDetails.loading,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
const AboutUsComponentRedux = connector(AboutUsComponent);

export { AboutUsComponentRedux as AboutUsComponent };
